import React from "react";
import { Box, Typography, Link } from "@mui/material";
import filler_arrow from '../../../../../asset/image/filled-arrow.svg';

interface InfoNoteProps {
    messages: { text: string; linkText?: string; linkUrl?: string }[];
    showIcon?: boolean;
}

const InfoNote: React.FC<InfoNoteProps> = ({ messages, showIcon = false }) => {
    return (
        <Box
            sx={{
                backgroundColor: "#F2F8FF",
                borderRadius: "12px",
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                paddingBottom: '78px'
            }}
        >
            {messages.map((msg, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                    {showIcon && (
                        <img src={filler_arrow} alt="" />
                    )}
                    <Typography variant="body2" sx={{ color: "#333" }}>
                        <span className="value-text">{msg.text}</span>{" "}
                        {msg.linkText && msg.linkUrl && (
                            <Link
                                href={msg.linkUrl}
                                target="_blank"
                                rel="noopener"
                                sx={{
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    fontSize: '12px',
                                    color: 'rgba(0, 0, 238, 1)',
                                    textDecoration: 'none'
                                }}
                            >
                                {msg.linkText}
                            </Link>
                        )}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default InfoNote;